import React from 'react';
import { Link } from 'react-router-dom';
import './VerificationSuccess.css';

const VerificationSuccess: React.FC = () => {
  return (
    <div className="verification-page">
      {/* Header */}
      <header className="verification-page__header">
        <div className="verification-page__container">
          <Link to="/" className="verification-page__logo">
            <img
              src="/ralli-logo.svg"
              alt="RalliPB Logo"
              className="verification-page__logo-img"
            />
            RalliPB
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="verification-page__content">
        <div className="verification-page__card">
          {/* Success Icon */}
          <div className="verification-page__icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2.5}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>

          <h1 className="verification-page__title">
            Email Verified
          </h1>

          <p className="verification-page__subtitle">
            Your email has been successfully verified for RalliPB beta and app store availability updates.
          </p>

          <div className="verification-page__divider" />

          <div className="verification-page__instruction">
            <svg
              className="verification-page__instruction-icon"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
            </svg>
            <span className="verification-page__instruction-text">
              RalliPB is not currently available on the Apple App Store or Google Play. We'll notify you when beta access or public store availability changes.
            </span>
          </div>

          <div className="verification-page__app-badge">
            Beta Waitlist Confirmed
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="verification-page__footer">
        <div className="verification-page__container">
          <p>&copy; {new Date().getFullYear()} RalliPB. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default VerificationSuccess;
